import { render } from "./KioskView.vue?vue&type=template&id=435d0a80"
import script from "./KioskView.vue?vue&type=script&lang=js"
export * from "./KioskView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__